import { IRecruiterDashboardMetrics } from '../../../../../hooks/useRecruiterDashboardMetrics';
import { METRIC_HIGHER_IS_BETTER, RATIO_BREAKPOINTS } from '../../../constants';
import { IDateBounds, IModalLabels, IRatioDetailsData } from '../../types';
import { getThresholdStatus } from '../getThresholdStatus';

export function buildRatioModalData(
  metrics: IRecruiterDashboardMetrics | null,
  dateBounds: IDateBounds,
  labels: IModalLabels
): IRatioDetailsData | null {
  if (!metrics) return null;

  const firstTime = metrics.ratioFirstTime;
  const repeat = metrics.ratioRepeat;
  const firstTimePct =
    firstTime + repeat > 0 ? (firstTime / (firstTime + repeat)) * 100 : 0;

  const status = getThresholdStatus(
    firstTimePct,
    RATIO_BREAKPOINTS,
    { low: labels.statusGood, mid: labels.statusOk, high: labels.statusPoor },
    METRIC_HIGHER_IS_BETTER.ratio
  );

  return {
    periodLabel: labels.currentPeriod,
    periodStart: dateBounds.start,
    periodEnd: dateBounds.end,
    ratioFirstTime: firstTime,
    ratioRepeat: repeat,
    firstTimeDonorCount: Math.max(
      0,
      metrics.activeDonorCount - metrics.repeatDonorCount
    ),
    repeatDonorCount: metrics.repeatDonorCount,
    activeDonorCount: metrics.activeDonorCount,
    statusLabel: status.label,
    statusColor: status.color,
  };
}
